import { useState } from "react";

import { H2Tag, H5Tag } from "@tm/static";
import { InnerContentWrap, useBreakpointV2 } from "@tm/ui-widgets";
import { FormattedText, TextNodeType } from "@tm/ui-widgets/components";
import {
  LandingFaqList,
  LandingFaqQues,
  LandingFaqStyle,
} from "./LandingFaq.style";

interface FaqType {
  customTitle?: string;
  customFaq?: string;
  faq: {
    ques?: TextNodeType | string;
    info?: string;
  }[];
  margin?: string;
}

const LandingFaq = ({ customTitle, customFaq, faq, margin }: FaqType) => {
  const [exp, setExp] = useState(-1);
  const device = useBreakpointV2();

  const handleClick = (index: number) => {
    exp != index ? setExp(index) : setExp(-1);
  };

  return (
    <LandingFaqStyle margin={margin} customFaq={customFaq}>
      <InnerContentWrap>
        {device == "lg" ? (
          <H2Tag margin="0 0 24px 0">
            {customTitle && <FormattedText value={customTitle} />}
          </H2Tag>
        ) : (
          <H5Tag margin="0 0 24px 16px">
            {customTitle && <FormattedText value={customTitle} />}
          </H5Tag>
        )}

        <LandingFaqList customFaq={customFaq}>
          {faq.map((item, index: number) => {
            return (
              <li
                className={`${exp == index ? "open" : "close"}`}
                key={index}
                onClick={() => handleClick(index)}
              >
                <LandingFaqQues customFaq={customFaq}>
                  {item.ques && <FormattedText value={item.ques} />}
                </LandingFaqQues>
                <p className="faq-content">
                  {item.info && (
                    <FormattedText
                      value={item.info}
                      baseStyle={{ whiteSpace: "pre-line" }}
                    />
                  )}
                </p>
              </li>
            );
          })}
        </LandingFaqList>
      </InnerContentWrap>
    </LandingFaqStyle>
  );
};

export default LandingFaq;
